import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";
import { track } from "@/lib/ads";
import { trackStep } from "@/components/site/VisitTracker";
import { useLang } from "@/lib/i18n";

const CartCtx = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const v = JSON.parse(localStorage.getItem("ozy_cart") || "[]");
      return Array.isArray(v) ? v : [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);
  const { lang } = useLang();

  useEffect(() => {
    localStorage.setItem("ozy_cart", JSON.stringify(items));
  }, [items]);

  const add = (p, qty = 1) => {
    track("AddToCart", { value: Number(p.price || 0) * qty, content_ids: [p.slug] });
    trackStep("cart");
    setItems((cur) => {
      const ex = cur.find((i) => i.slug === p.slug);
      if (ex) return cur.map((i) => (i.slug === p.slug ? { ...i, quantity: i.quantity + qty } : i));
      return [...cur, { slug: p.slug, name: p.name, price: p.price, image: p.image, category: p.category, quantity: qty, ...(p.preorder ? { preorder: true, preorder_date: p.preorder_date || "" } : {}) }];
    });
    toast.success(lang === "en" ? `${p.name} added to cart` : `${p.name} ajouté au panier`);
    setOpen(true);
  };
  const setQty = (slug, q) =>
    setItems((cur) => (q <= 0 ? cur.filter((i) => i.slug !== slug) : cur.map((i) => (i.slug === slug ? { ...i, quantity: q } : i))));
  const clear = () => setItems([]);
  const addBox = (box) => {
    const slug = `coffret-${Date.now()}`;
    const price = Math.round(box.reduce((s, b) => s + b.price * b.qty, 0) * 100) / 100;
    trackStep("cart");
    setItems((cur) => [...cur, { slug, name: "Mon pack Ozentya", price, image: box[0]?.image, quantity: 1, box }]);
    toast.success(lang === "en" ? "Your pack has been added to the cart" : "Votre pack a été ajouté au panier");
    setOpen(true);
  };

  const value = useMemo(() => {
    const count = items.reduce((s, i) => s + i.quantity, 0);
    const total = items.reduce((s, i) => s + i.quantity * i.price, 0);
    return { items, add, addBox, setQty, clear, count, total, open, setOpen };
  }, [items, open]);

  return <CartCtx.Provider value={value}>{children}</CartCtx.Provider>;
}

export const useCart = () => useContext(CartCtx);
